import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js'
import Loader from './../shared/loader'

import {
	Validator
} from 'vee-validate'
export default {
	name: 'removehold',
	components: {
		Paginate,
		Loader
	},
	props: [],
	data() {
		return {
			isLoading: false,
			totalRows: 0,
			currentPage: 0,
			invreferenceid: '',
			invoiceno: '',
			client: '',
			ClientErr: '',
			WarehouseErr: '',
			clientid: '',
			isError: '',
			holdreason: '',
			warehouse: '',
			warehouseid:'',
			pageno: 0,
			pageCount: 0,
			addholdmodal: false,
			isError: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			listInboundData: [],
			Deatils: [],
			selected: [],

			listReasonData: [],
			checkedreasons: [],
			listClientData: [],
			listWarehouseData: [],
			addhold: {
				Acceptedqty: '',
				rejectedqty: ''
			}
		}
	},
	computed: {
		selectAll: {
			get() {
				return this.selected.length === this.listReasonData.length
			},
			set(value) {
				this.selected = []
				if (value) {
					this.listReasonData.forEach((select) => {
						this.selected.push(select.reasonname)
					})
				}
			}
		},
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);

		this.pageNo = 0;
		// this.getClientList();
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				console.log(userdetail);
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.showSelectClient = true;
				this.showSelectWarehouse = false;
				this.getInboundData();
				break;
			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				this.showSelectWarehouse = false;
				// this.getClientList();
				break;
			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

	},
	methods: {
		check: function(e) {
			if (e.target.checked) {
				console.log(e.target.value)
			}
		},

		getreasonlist() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			this.input = ({
				clientid: this.clientid
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getReasonlist',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listReasonData = result.data;
				}, error => {
					console.error(error);
				});
		},
		//to get clientlist
		// getClientList() {
		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;
		// 	this.input = ({
		// 		warehouseid: this.warehouseid,
		// 	});
		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listClientData = result.data.data;
		// 		}, error => {
		// 			console.error(error);
		// 		});
		// },
		// getWarehouseList() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;
		// 	this.input = ({
		// 		clientid: this.clientid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			// console.log(result.data.data);
		// 			this.listWarehouseData = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },
		//on change of client
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		if (this.clientid) {
		// 			this.getWarehouseList();
		// 		}
		// 	}

		// },

		//Edit hold action data
		removeHold(data) {
			this.addholdmodal = true
			this.addhold.onholdquantity = data.onholdquantity
			this.addhold.grcno = data.grcno
			this.Deatils = data
			this.resetflt();
			this.$validator.reset();
			this.errors.clear();
		},
		//close modal
		closeaddholdmodal() {
			this.addholdmodal = false;
		},
		//get Hold list
		getInboundData(data) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error('Please Select Client')
				this.pageNo = this.pageCount = 0;
				this.listInboundData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error('Please Select Warehouse')
				this.pageNo = this.pageCount = 0;
				this.listInboundData = [];
				return false;
			}
			this.input = ({
				offset: this.pageno,
				limit: 10,
				invreferenceid: this.invreferenceid.trim(),
				invoiceno: this.invoiceno.trim(),
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse')
			})
			this.isLoading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'GetInbounduserList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listInboundData = result.data.data
					this.totalRows = result.data.count
					if (this.totalRows < 10) {
						this.pageCount = 0
						this.pageCount = Math.ceil(this.totalRows / 10)
					}
					this.isLoading = false
				}, error => {
					console.error(error)
				})
		},
		//to paginationate data
		getPaginationData(currentPage) {
			this.pageno = (currentPage - 1) * 10
			this.getInboundData()
		},
		//to reset form
		resetflt() {
			this.addhold.Acceptedqty = '',
				this.addhold.rejectedqty = '',
				this.isError = '';
			this.selected = [];
			this.totalRows = 0;
			this.getInboundData();
		},
		resetForm() {
			this.totalRows = 0;
			this.listInboundData = [];
			this.invreferenceid = '',
				this.invoiceno = '',
				this.client = '';
			this.warehouse = '';
			// this.clientid = '';
			this.pageCount = 0

		},
		checkQty() {
			this.getreasonlist();
			this.isError = 0;
			this.Qtyerrors = '';
		},
		//to save hold removed action
		saveHoldQtyData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if (this.addhold.Acceptedqty != '' && this.addhold.rejectedqty != '') {
				var Acceptedqty = parseInt(this.addhold.Acceptedqty)
				var rejectedqty = parseInt(this.addhold.rejectedqty)
				var sum = Acceptedqty + rejectedqty
				if (this.addhold.onholdquantity != sum) {
					this.isError = 1;
					this.Qtyerrors = this.$t('removeHold.sumOfAcceptAndRejQty');
					return false;
				} else {
					this.isError = 0;
					this.Qtyerrors = '';
				}
			}
			var rreasons = [];
			for (var i = 0; i < this.selected.length; i++) {
				rreasons.push({
					"rejectreason": this.selected[i],
					"createddate": new Date()
				})
			}
			axios.post(apiUrl.api_url + 'SaveHolddata', {
					'clientid': this.clientid,
					'checkedquantity': this.addhold.Acceptedqty,
					'rejectedquantity': this.addhold.rejectedqty,
					'grcno': this.addhold.grcno,
					'rejectreasons': rreasons,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.msg == 1) {
						this.$alertify.success(this.$t('removeHold.holdRemoved'))
						this.addholdmodal = false
						this.getInboundData();
						this.resetflt();
					} else {
						this.getInboundData();
						this.resetflt();
						this.$alertify.error(this.$t('removeHold.error'))
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		//on submit data
		onSubmit: function(event) {
			this.$validator.validateAll().then(() => {
				event.target.reset();
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/removehold/removehold.component.js